import { Icon } from '../../icon'
import { UnstyledButton } from '../UnstyledButton'
import { styled } from '../../../styled-components'

import { ThemeColors } from '../../../new/theme'

// required for styling nested elements on StyledButton
export const StyledIcon = styled(Icon)``

export const StyledButton = styled(UnstyledButton)<{ bg?: ThemeColors; color?: ThemeColors }>`
  :not(:disabled) {
    :hover,
    :focus-visible {
      background: ${({ theme, bg }) =>
        bg ? theme.colors[bg] : theme.colors['bg/action-bar-button-hovered-caution']};

      ${StyledIcon} {
        color: ${({ theme, color }) =>
          color ? theme.colors[color] : theme.colors['icon/action-caution']};
      }
    }

    ${StyledIcon} {
      color: ${({ theme, color }) =>
        color ? theme.colors[color] : theme.colors['icon/action-minor']};
    }
  }

  :disabled,
  :disabled:hover {
    background: ${({ theme }) => theme.colors['bg/disabled']};
  }
`
